import { clientClient, personalDataClient } from 'servicesCommon/client';
import { AxiosTypedPromise, SuccessResponse } from 'servicesCommon/apiTypes';
import {
	UpdateUserProfile,
	UserInfoRequest,
	UserInfoResponse,
	UserProfileCustomerInfoResponse,
} from './UserProfileTypes';
import { urlFormatter } from 'utils/utils';

const formatUrl = (url: string) => `/info/${url}`;
const userUrl = urlFormatter('/customer-users');
export const userProfileApi = {
	getCustomerInfo(): AxiosTypedPromise<UserProfileCustomerInfoResponse> {
		return clientClient.get(formatUrl('get-customer-info'));
	},

	putCustomerInfo(data: UpdateUserProfile): AxiosTypedPromise<SuccessResponse> {
		return personalDataClient.put(userUrl('update-customer-user-by-customer-user'), data);
	},

	getUserInfo(userId: UserInfoRequest): AxiosTypedPromise<UserInfoResponse> {
		return personalDataClient.get(
			userUrl('get-customer-user-for-update-by-customer-user', userId)
		);
	},
};
